module.exports = {
    setup: function(elements) {
        elements.each(function(i, element) {
            // If the parents data attribute is set, use that and append to the URL below. This will alter the query if
            // true, and include parents in the search.
            var includeParents = $(element).data('parents') || 'false';
            var el = $(element);

            el.select2({
                ajax: {
                    url: '/category/autocomplete?parents=' + includeParents,
                    dataType: 'json',
                    delay: 250,
                    data: function(searchTerm) {
                        return {
                            name: searchTerm
                        }
                    },
                    results: function(data) {
                        return {
                            results: data
                        }
                    },
                    cache: true
                },
                formatResult: function(category) {
                    return category.title;
                },
                formatSelection: function(category) {
                    return category.title;
                },
                initSelection: function(element, callback) {
                    var id = $(element).data('selected-value');
                    var text = $(element).data('selected-text');
                    
                    callback({ 'id': id, 'title': text });
                },
                minimumInputLength: 3
            });
        });
    }
};
